import styled from 'styled-components'
import { media, mediaMax } from 'styles/media'

interface BreakpointProps {
  breakpoint: 'xxl' | 'xl' | 'lg' | 'md' | 'sm'
}

export const MobileOnly = styled.div<BreakpointProps>`
  ${({ breakpoint }) => media[breakpoint]`
    display: none;
  `}
`

export const DesktopOnly = styled.div<BreakpointProps>`
  ${({ breakpoint }) => mediaMax[breakpoint]`
    display: none;
  `}
`
